import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { connect } from 'dva';
import * as echarts from 'echarts';
import { chartColor } from "../../../../utils/commonConsts";
import { injectIntl } from "react-intl";
var AgencyFlowStat = /*#__PURE__*/function (_React$Component) {
  _inherits(AgencyFlowStat, _React$Component);
  function AgencyFlowStat(props) {
    var _this;
    _classCallCheck(this, AgencyFlowStat);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AgencyFlowStat).call(this, props)); /* getDataB = () => {
                                                                                                 this.props.dispatch({
                                                                                                 type: "ci0301Info/getStatisticsB",
                                                                                                 payload: {
                                                                                                 item: "steps",
                                                                                                 companyid: this.props.companyid,
                                                                                                 start_tm: this.props.start_tm,
                                                                                                 end_tm: this.props.end_tm,
                                                                                                 top: this.props.data_num,
                                                                                                 }
                                                                                                 })
                                                                                                 };*/
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeSrcIpB", function (e) {
      _this.setState({
        srcIpB: e.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeDesIpB", function (e) {
      _this.setState({
        desIpB: e.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "changeDesPortB", function (e) {
      _this.setState({
        desPortB: e.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "searchB", function () {
      _this.props.dispatch({
        type: "ci0301Info/getTableB",
        payload: {
          tableFlag: true,
          item: "apprank",
          companyid: _this.props.companyid,
          start_tm: _this.props.start_tm,
          step_sn: _this.state.selectedStepSn,
          end_tm: _this.props.end_tm,
          top: _this.props.data_num,
          src_ip: _this.state.srcIpB,
          dst_ip: _this.state.desIpB,
          dst_port: _this.state.desPortB
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "editAppName", function (e) {
      _this.setState({
        appName: e.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "submitAppNameEditB", function (visible, record) {
      if (visible) {
        _this.setState({
          appName: record.name
        });
      } else {
        _this.props.dispatch({
          type: "ci0301Info/update_app_nameB",
          payload: {
            edit: {
              id: record.id,
              name: _this.state.appName
            },
            refresh: {
              item: "apprank",
              companyid: parseInt(sessionStorage.getItem("companyId")),
              start_tm: _this.props.start_tm,
              step_sn: _this.state.selectedStepSn,
              end_tm: _this.props.end_tm,
              top: _this.props.data_num,
              src_ip: _this.state.srcIpB,
              dst_ip: _this.state.desIpB,
              dst_port: _this.state.desPortB
            }
          }
        });
      }
    });
    _this.state = {
      selectedStepSn: "",
      srcIpB: "",
      desIpB: "",
      desPortB: ""
    };
    return _this;
  }
  _createClass(AgencyFlowStat, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.histogramElB = echarts.init(document.getElementById("chartB")); /*this.getDataB();*/
      this.renderHistogramB(this.histogramElB, "节点名称", this.props.ci0301Info.lineSeriesB);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderHistogramB(this.histogramElB, "节点名称", this.props.ci0301Info.lineSeriesB);
    }
  }, {
    key: "renderHistogramB",
    value: function renderHistogramB(el, yName, lineData) {
      var histogram = el;
      histogram.clear();
      var option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: "#333",
          extraCssText: 'box-shadow: 0 2px 2px 0 rgba(24,24,24,0.60);border-radius: 2px 2px 0 0 0 2px 2px;',
          formatter: function formatter(data) {
            var res = '';
            for (var i = 0; i < data.length; i++) {
              res += '<tr><td><span style="font-size:32px;color:' + data[i].color + '">&middot;</span>' + data[i].seriesName + '</td><td>' + data[i].data[1] + '<td/><td>' + data[i].data[0] + '</td></tr>';
            }
            return '<div class="line-tooltip"><table class="line-tooltip-table" style="border-bottom: none">' + res + '<table/></div>';
          }
        },
        grid: {
          bottom: '20%'
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          min: this.props.start_tm,
          max: this.props.end_tm,
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,0.45)"
            }
          }
        },
        legend: {
          left: "center",
          bottom: 0,
          icon: "circle"
        },
        yAxis: [{
          type: 'value',
          name: '@速率(Mbps)',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        }],
        series: lineData,
        color: chartColor
      };
      histogram.setOption(option); /* histogram.off("mouseover");//防止累计触发
                                   histogram.on("mouseover", function (params) {
                                   vm.getTableB(vm.props.ci0301Info.step_sn_b[params.dataIndex]);
                                   });*/
    }
  }, {
    key: "getTableB",
    value: function getTableB(step_sn) {
      this.setState({
        selectedStepSn: step_sn
      });
      this.props.dispatch({
        type: "ci0301Info/getTableB",
        payload: {
          item: "apprank",
          companyid: this.props.companyid,
          start_tm: this.props.start_tm,
          end_tm: this.props.end_tm,
          top: this.props.data_num,
          step_sn: step_sn
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
        style: {
          height: 500,
          width: document.body.clientWidth - 300
        },
        id: "chartB"
      })));
    }
  }]);
  return AgencyFlowStat;
}(React.Component);
function mapDispatchToProps(_ref) {
  var ci0301Info = _ref.ci0301Info;
  return {
    ci0301Info: ci0301Info
  };
}
export default connect(mapDispatchToProps)(injectIntl(AgencyFlowStat));